// extracted by mini-css-extract-plugin
export default {"label":"CheckboxComponent_label__Jllva"};